export default {
  ActivityLogImportJob: 'Importación de registro de actividad',
  AllSurveysDataMigrationJob: 'Migración de datos de todas las encuestas',
  ArenaMobileDataImportJob: 'Importación de datos de Arena',
  ArenaMobileDataImportSummaryJob: 'Resumen de importación de datos de Arena',
  CategoriesImportJob: 'Importación de categorías',
  CategoriesValidationJob: 'Validación de categorías',
  CategoriesBatchImportJob: 'Importación de categorías',
  CategoryImportJob: 'Importación de categoría',
  CategoryImportInternalJob: 'Importación de categoría',
  CategoryBatchImportJob: 'Importación de categoría',
  CategoryBatchImportInternalJob: 'Importación de categoría',
  CategoryValidationJob: 'Validación de categoría',
  ChainsSamplingNodeDefsCheckJob: 'Procesando la creación de definiciones de nodos de muestreo de cadenas',
  ChainsValidationJob: 'Validación de cadenas de procesamiento',
  ChainsImportJob: 'Importación de cadenas',
  CollectDataImportJob: 'Importación de datos de Collect',
  CollectImportJob: 'Importación de Collect',
  CollectSurveyReaderJob: 'Lector de encuestas de Collect',
  CyclesDeletedCheckJob: 'Verificación de ciclos eliminados',
  DataDeleteJob: 'Eliminación de datos',
  DataImportJob: 'Importación de datos',
  DataImportValidationJob: 'Validación de archivos de importación de datos',
  EntitiesDeleteJob: 'Eliminación de entidades existentes',
  FilesImportJob: 'Importación de archivos',
  MessageSendJob: 'Enviar mensaje',
  NodeDefsTranslationJob: 'Traducción de etiquetas de definiciones de nodos',
  NodeDefsImportJob: 'Importación de definiciones de nodos',
  NodeDefsValidationJob: 'Validación de definiciones de nodos',
  OdkImportJob: 'Importación de ODK',
  OdkDataImportJob: 'Importación de datos de ODK',
  OdkFormReaderJob: 'Lector de formulario de ODK',
  OdkSubmissionReaderJob: 'Lector de envíos de ODK',
  ChainsCyclesCheckJob: 'Verificación de ciclos de cadenas',
  RecordCheckJob: 'Verificación de registro',
  RecordsCloneJob: 'Clonación de registros',
  RecordsImportJob: 'Importación de registros',
  RecordsImportSummaryJob: 'Resumen de importación de registros',
  RecordsUniquenessValidationJob: 'Validación de unicidad de registros',
  SamplingPointDataImportJob: 'Importación de datos de puntos de muestreo',
  SamplingPointDataImportInternalJob: 'Importación de datos de puntos de muestreo',
  SchemaSummaryExportJob: 'Exportación del resumen del esquema',
  SelectedRecordsExportJob: 'Exportación de registros seleccionados',
  SurveyActivityLogClearJob: 'Borrar registro de actividad de la encuesta',
  SurveyCreatorJob: 'Creación de encuesta',
  SurveyDataMigrationJob: 'Migración de datos de la encuesta',
  SurveyDependencyGraphsGenerationJob: 'Generación de gráficos de dependencia de encuestas',
  SurveyExportJob: 'Exportación de encuesta',
  SurveyCompareJob: 'Comparación de encuestas',
  SurveyCompareDiffJob: 'Cálculo de las diferencias',
  SurveyCompareApplyJob: 'Aplicación de los cambios de la encuesta',
  SurveyFilesImportJob: 'Importación de archivos de encuesta',
  SurveyIndexGeneratorJob: 'Generador de índices de encuestas',
  SurveyInfoValidationJob: 'Validación de información de encuesta',
  SurveyLabelsImportJob: 'Importación de etiquetas de encuestas',
  SurveyPropsPublishJob: 'Publicar propiedades de la encuesta',
  SurveyPublishJob: 'Publicar encuesta',
  SurveyPublishPerformJob: 'Realizar publicación de encuesta',
  SurveyRdbCreationJob: 'Creación de RDB de encuesta',
  SurveyRdbSchemaCreationJob: 'Creación del esquema de RDB de encuesta',
  SurveyRdbDataTablesAndViewsCreationJob: 'Creación de tablas y vistas de datos de RDB de encuesta',
  SurveyRdbOlapDataTablesCreationJob: 'Creación de tablas de datos OLAP de RDB de encuesta',
  SurveyUnpublishJob: 'Anular publicación de encuesta',
  SurveyPropsUnpublishJob: 'Anular publicación de propiedades de la encuesta',
  SurveysListExportJob: 'Exportación de lista de encuestas',
  SurveysRdbRefreshJob: 'Actualización de RDB de encuestas',
  TaxonomiesImportJob: 'Importación de taxonomías',
  TaxonomiesValidationJob: 'Validación de taxonomías',
  TaxonomyImportJob: 'Importación de taxonomía',
  UsersBackupExportJob: 'Copia de seguridad de usuarios',
  UsersBackupImportJob: 'Restauración de usuarios',
  // data export
  ArenaFileReadJob: 'Lectura de archivo de Arena',
  DataExportJob: 'Exportación de datos',
  DataSummaryExportJob: 'Exportación de resumen de datos',
  ZipCreationJob: 'Creación de archivo ZIP',
  CSVDataExtraction: 'Extracción de datos',
  FilesExportJob: 'Exportación de archivos',
  PrepareImportFileJob: 'Preparar archivo de importación',
  // geo
  GeoJsonDataExportJob: 'Exportación de datos GeoJson',
  // import arena survey
  ArenaImportJob: 'Importación de Arena',
  ArenaSurveyReaderJob: 'Lector de encuestas de Arena',
  CreateRdbJob: 'Creación de RDB de encuesta',
  UsersImportJob: 'Importación de usuarios',
  // clone survey
  SurveyCloneJob: 'Clonar encuesta',
  CloneSurveyJob: 'Clonar encuesta',
  // survey backup
  SurveyInfoExportJob: 'Exportación de información de encuesta',
  CategoriesExportJob: 'Exportación de categorías',
  CategoryGeoPackageExportJob: 'Exportación de categoría a GeoPackage',
  SamplingPointDataWhispJob: 'Análisis Whisp de los datos de puntos de muestreo',
  SamplingPointDataWhispAnalysisJob: 'Análisis Whisp',
  SamplingPointDataWhispCategoryImportJob: 'Importación de la categoría Whisp',
  TaxonomiesExportJob: 'Exportación de taxonomías',
  RecordsExportJob: 'Exportación de registros',
  RecordFilesExportJob: 'Exportación de archivos de registros',
  SurveyFilesExportJob: 'Exportación de archivos de encuesta',
  ChainExportJob: 'Exportación de cadena',
  UsersExportJob: 'Exportación de usuarios',
  ActivityLogExportJob: 'Exportación de registro de actividad',
  InfoExportJob: 'Generación de información del archivo de salida',
  // validation report
  VaidationReportGenerationJob: 'Generar informe de validación',
  // record Validation
  RecordsValidationJob: 'Validación de registros',
  // analysis
  PersistResultsJob: 'Persistencia de resultados del análisis',
  PersistOlapDataJob: 'Persistencia de datos OLAP',
}
